module.exports = __webpack_public_path__ + "img/TZS09523.30888dd2.jpeg";